import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { ProcessingCanvas } from '@/features/app-shell/canvases/processing-canvas'

type ProcessingSearch = {
  projectId: string
}

export const Route = createFileRoute('/app/processing')({
  validateSearch: (search: Record<string, unknown>): ProcessingSearch => ({
    projectId: typeof search.projectId === 'string' ? search.projectId : '',
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppProcessingPage,
})

function AppProcessingPage() {
  const search = useSearch({ from: '/app/processing' })

  return (
    <AppShell activePath="/app">
      <ProcessingCanvas projectId={search.projectId} />
    </AppShell>
  )
}
